import Vue from "vue";
import Router from "vue-router";

import alipay from "@/view/pay/alipay";
import notify_url from "@/view/pay/notify_url";
import return_url from "@/view/pay/return_url";

//解决路由重复点击报错的问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: resolve => require(["@/view/login"], resolve)
    },
    {
      path: "/register",
      name: "register",
      component: resolve => require(["@/view/register.vue"], resolve)
    },
    {
      path: "/password",
      name: "password",
      component: resolve => require(["@/view/password.vue"], resolve)
    },
    {
      path: "/userInfo",
      name: "userInfo",
      component: resolve => require(["@/view/userinfo/userInfo"], resolve)
    },
    {
      path: "/",
      name: "index",
      component: resolve => require(["@/view/index"], resolve)
    },
    {
      path: "/ehcInformation",
      name: "ehcInformation",
      component: resolve => require(["@/view/ehcInformation"], resolve)
    },
    {
      path: "/ehcCase",
      name: "ehcCase",
      component: resolve => require(["@/view/ehcCase"], resolve)
    },
    {
      path: "/boshanCase",
      name: "boshanCase",
      component: resolve => require(["@/view/ehcCase/boshanCase"], resolve)
    },
    {
      path: "/tangshanCase",
      name: "tangshanCase",
      component: resolve => require(["@/view/ehcCase/tangshanCase"], resolve)
    },
    {
      path: "/changanCase",
      name: "changanCase",
      component: resolve => require(["@/view/ehcCase/changanCase"], resolve)
    },
    {
      path: "/ebdData",
      name: "ebdData",
      component: resolve => require(["@/view/ebdData"], resolve)
    },
    {
      path: "/ebdSearch",
      name: "ebdSearch",
      component: resolve => require(["@/view/ebdSearch"], resolve)
    },
    {
      path: "/dataDetail1",
      name: "dataDetail1",
      component: resolve => require(["@/view/ebdData/dataDetail1.vue"], resolve)
    },
    {
      path: "/dataDetail2",
      name: "dataDetail2",
      component: resolve => require(["@/view/ebdData/dataDetail2.vue"], resolve)
    },
    {
      path: "/dataDetail3",
      name: "dataDetail3",
      component: resolve => require(["@/view/ebdData/dataDetail3.vue"], resolve)
    },
    {
      path: "/dataDetail4",
      name: "dataDetail4",
      component: resolve => require(["@/view/ebdData/dataDetail4.vue"], resolve)
    },
    {
      path: "/dataDetail5",
      name: "dataDetail5",
      component: resolve => require(["@/view/ebdData/dataDetail5.vue"], resolve)
    },
    {
      path: "/dataDetail6",
      name: "dataDetail6",
      component: resolve => require(["@/view/ebdData/dataDetail6.vue"], resolve)
    },
    {
      path: "/dataDetail7",
      name: "dataDetail7",
      component: resolve => require(["@/view/ebdData/dataDetail7.vue"], resolve)
    },
    {
      path: "/dataDetail8",
      name: "dataDetail8",
      component: resolve => require(["@/view/ebdData/dataDetail8.vue"], resolve)
    },
    {
      path: "/dataDetail9",
      name: "dataDetail9",
      component: resolve => require(["@/view/ebdData/dataDetail9.vue"], resolve)
    },
    {
      path: "/dataDetail10",
      name: "dataDetail10",
      component: resolve =>
        require(["@/view/ebdData/dataDetail10.vue"], resolve)
    },
    {
      path: "/dataDetail11",
      name: "dataDetail11",
      component: resolve =>
        require(["@/view/ebdData/dataDetail11.vue"], resolve)
    },
    {
      path: "/aboutUs",
      name: "aboutUs",
      component: resolve => require(["@/view/aboutUs.vue"], resolve)
    },
    // 常规分析 模块
    {
      path: "/ruleAnalyse",
      name: "ruleAnalyse",
      component: resolve => require(["../components/ruleAnalyse.vue"], resolve),
      children: [
        {
          path: "calendarCity",
          name: "CalendarCity",
          component: resolve =>
            require(["@/view/ruleAnalyse/calendar/calendarCity.vue"], resolve)
        },
        {
          path: "calendarMp",
          name: "CalendarMp",
          component: resolve =>
            require(["@/view/ruleAnalyse/calendar/calendarMp.vue"], resolve)
        },
        {
          path: "mapDisCity",
          name: "MapDisCity",
          component: resolve =>
            require([
              "@/view/ruleAnalyse/mapDistribution/mapDisCity.vue"
            ], resolve)
        },
        {
          path: "mapDisMp",
          name: "MapDisMp",
          component: resolve =>
            require([
              "@/view/ruleAnalyse/mapDistribution/mapDisMp.vue"
            ], resolve)
        },
        {
          path: "rankingCity",
          name: "RankingCity",
          component: resolve =>
            require(["@/view/ruleAnalyse/ranking/rankingCity.vue"], resolve)
        },
        {
          path: "rankingMp",
          name: "RankingMp",
          component: resolve =>
            require(["@/view/ruleAnalyse/ranking/rankingMp.vue"], resolve)
        },
        {
          path: "statistics/month/city",
          name: "MonthCity",
          component: resolve =>
            require(["@/view/ruleAnalyse/statistics/month/city.vue"], resolve)
        },
        {
          path: "statistics/month/mp",
          name: "MonthMp",
          component: resolve =>
            require(["@/view/ruleAnalyse/statistics/month/mp.vue"], resolve)
        },
        {
          path: "statistics/year/city",
          name: "StatisticsYearCity",
          component: resolve =>
            require(["@/view/ruleAnalyse/statistics/year/city.vue"], resolve)
        },
        {
          path: "statistics/year/mp",
          name: "StatisticsYearMp",
          component: resolve =>
            require(["@/view/ruleAnalyse/statistics/year/mp.vue"], resolve)
        },
        {
          path: "compareCity",
          name: "CompareCity",
          component: resolve =>
            require(["@/view/ruleAnalyse/compare/city.vue"], resolve)
        },
        {
          path: "compareMp",
          name: "CompareMp",
          component: resolve =>
            require(["@/view/ruleAnalyse/compare/mp.vue"], resolve)
        }
      ]
    },
    //  报告编辑页面
    {
      path: "/report/editor",
      name: "ReportEditor",
      component: resolve =>
        require(["@/view/causeAnalyse/ReportEditor.vue"], resolve)
    },
    {
      path: "/report/view",
      name: "ReportView",
      component: resolve =>
        require(["@/view/causeAnalyse/ReportView.vue"], resolve)
    },
    // 大气污染成因分析 模块
    {
      path: "/causeAnalyse",
      name: "CauseAnalyse",
      meta: {
        title: "大气污染成因分析"
      },
      component: resolve =>
        require(["../components/causeAnalyse.vue"], resolve),
      children: [
        {
          path: "ruleRate",
          name: "RuleRate",
          meta: {
            order: 1,
            title: "空气质量分析",
            subtitle: "常规污染物及比值演变趋势"
          },
          component: resolve =>
            require(["@/view/causeAnalyse/airQuality/ruleRate.vue"], resolve),
          children: [
            //折线图1
            {
              path: "line",
              name: "RuleRateLine",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/RuleRateLine.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 1,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree-zhe-1.jpg")
              }
            },
            //折线图2
            {
              path: "line2",
              name: "RuleRateLine2",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/RuleRateLine2.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 2,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree-zhe-2.jpg")
              }
            },
            //柱状图1
            {
              path: "bar",
              name: "RuleRateBar",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/RuleRateBar.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 3,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree-zhu-1.jpg")
              }
            },
            //柱状图2
            {
              path: "bar2",
              name: "RuleRateBar2",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/RuleRateBar2.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 4,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree-zhu-2.jpg")
              }
            },
            //面积图1
            {
              path: "area",
              name: "RuleRateArea",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/RuleRateArea.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 5,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree-mian-1.jpg")
              }
            },
            //面积图2
            {
              path: "area2",
              name: "RuleRateArea2",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/RuleRateArea2.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 6,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree-mian-2.jpg")
              }
            },
            //混合图1
            {
              path: "mix",
              name: "RuleRateMix",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/RuleRateMix.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 7,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree-hun-1.jpg")
              }
            },
            //混合图2
            {
              path: "mix2",
              name: "RuleRateMix2",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/RuleRateMix2.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 8,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree-hun-2.jpg")
              }
            }
          ]
        },
        {
          path: "accrualRate",
          name: "AccrualRate",
          meta: {
            order: 2,

            title: "空气质量分析",
            subtitle: "污染物浓度累计率"
          },
          component: resolve =>
            require([
              "@/view/causeAnalyse/airQuality/accrualRate.vue"
            ], resolve),
          children: [
            {
              path: "AccrualRateLine",
              name: "AccrualRateLine",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/AccrualRateLine.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 1,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree_rate-zhe-1.jpg")
              }
            },
            {
              path: "AccrualRateBar",
              name: "AccrualRateBar",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/AccrualRateBar.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 2,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree_rate-zhu-1.jpg")
              }
            },
            {
              path: "AccrualRateArea",
              name: "AccrualRateArea",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/AccrualRateArea.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 3,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree_rate-mian-1.jpg")
              }
            }
          ]
        },
        {
          path: "spatialSpace",
          name: "SpatialSpace",
          meta: {
            order: 3,
            title: "空气质量分析",
            subtitle: "污染物空间分布特征"
          },
          component: resolve =>
            require([
              "@/view/causeAnalyse/airQuality/spatialSpace.vue"
            ], resolve),
          children: [
            {
              path: "SpatialSpaceMaps",
              name: "SpatialSpaceMaps",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/SpatialSpaceMaps.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 1,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree_spatial-space-1.png")
              }
            },
            {
              path: "SpatialSpaceMappie",
              name: "SpatialSpaceMappie",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/SpatialSpaceMappie.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 2,
                imgUrl: require("@/assets/cause_analyse/pollutant_degree_spatial-bing-1.png")
              }
            }
          ]
        },
        {
          path: "speedDirection",
          name: "SpeedDirection",
          meta: {
            order: 4,
            title: "气象分析",
            subtitle: "风速风向"
          },
          component: resolve =>
            require([
              "@/view/causeAnalyse/meteorologicalAnalysis/speedDirection.vue"
            ], resolve),
          children: [
            {
              path: "SpeedDirectionLine",
              name: "SpeedDirectionLine",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/SpeedDirectionLine.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 1,
                imgUrl: require("@/assets/cause_analyse/wind_speed-zhe-1.jpg")
              }
            },
            {
              path: "SpeedDirectionLine2",
              name: "SpeedDirectionLine2",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/SpeedDirectionLine2.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 2,
                imgUrl: require("@/assets/cause_analyse/wind_speed-zhe-2.jpg")
              }
            }
          ]
        },
        {
          path: "diagnosticRatios",
          name: "DiagnosticRatios",
          meta: {
            order: 5,
            title: "污染来源定向分析",
            subtitle: "特征比值分析"
          },
          component: resolve =>
            require([
              "@/view/causeAnalyse/sourceOrientation/diagnosticRatios.vue"
            ], resolve),
          children: [
            //折线图1
            {
              path: "DiagnosticRatiosLine",
              name: "DiagnosticRatiosLine",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/DiagnosticRatiosLine.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 1,
                imgUrl: require("@/assets/cause_analyse/ratio-zhe-1.jpg")
              }
            },
            //折线图2
            {
              path: "DiagnosticRatiosLine2",
              name: "DiagnosticRatiosLine2",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/DiagnosticRatiosLine2.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 2,
                imgUrl: require("@/assets/cause_analyse/ratio-zhe-2.jpg")
              }
            },
            //柱状图1
            {
              path: "DiagnosticRatiosBar",
              name: "DiagnosticRatiosBar",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/DiagnosticRatiosBar.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 3,
                imgUrl: require("@/assets/cause_analyse/ratio-zhu-1.jpg")
              }
            },
            //柱状图2
            {
              path: "DiagnosticRatiosBar2",
              name: "DiagnosticRatiosBar2",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/DiagnosticRatiosBar2.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 4,
                imgUrl: require("@/assets/cause_analyse/ratio-zhu-2.jpg")
              }
            },
            //面积图1
            {
              path: "DiagnosticRatiosArea",
              name: "DiagnosticRatiosArea",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/DiagnosticRatiosArea.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 5,
                imgUrl: require("@/assets/cause_analyse/ratio-mian-1.jpg")
              }
            },
            //面积图2
            {
              path: "DiagnosticRatiosArea2",
              name: "DiagnosticRatiosArea2",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/DiagnosticRatiosArea2.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 6,
                imgUrl: require("@/assets/cause_analyse/ratio-mian-2.jpg")
              }
            },
            //混合图1
            {
              path: "DiagnosticRatiosMix",
              name: "DiagnosticRatiosMix",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/DiagnosticRatiosMix.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 7,
                imgUrl: require("@/assets/cause_analyse/ratio-hun-1.jpg")
              }
            },
            //混合图2
            {
              path: "DiagnosticRatiosMix2",
              name: "DiagnosticRatiosMix2",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/DiagnosticRatiosMix2.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 8,
                imgUrl: require("@/assets/cause_analyse/ratio-hun-2.jpg")
              }
            }
          ]
        },
        {
          path: "relevance",
          name: "Relevance",
          meta: {
            order: 6,
            title: "污染来源定向分析",
            subtitle: "相关性分析"
          },
          component: resolve =>
            require([
              "@/view/causeAnalyse/sourceOrientation/relevance.vue"
            ], resolve),
          children: [
            //散点图
            {
              path: "scatter",
              name: "RelevanceScatter",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/RelevanceScatter.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 1,
                imgUrl: require("@/assets/cause_analyse/relevance-1.jpg")
              }
            }
          ]
        },
        {
          path: "sourceDirection",
          name: "SourceDirection",
          meta: {
            order: 7,
            title: "污染来源定向分析",
            subtitle: "源来向分析"
          },
          component: resolve =>
            require([
              "@/view/causeAnalyse/sourceOrientation/sourceDirection.vue"
            ], resolve),
          children: [
            {
              path: "radar",
              name: "SourceDirectionRadar",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/SourceDirectionRadar.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 1,
                imgUrl: require("@/assets/cause_analyse/origin-1.jpg")
              }
            }
          ]
        },
        {
          path: "featuresRadar",
          name: "FeaturesRadar",
          meta: {
            order: 8,
            title: "污染来源定向分析",
            subtitle: "特征雷达图"
          },
          component: resolve =>
            require([
              "@/view/causeAnalyse/sourceOrientation/featuresRadar.vue"
            ], resolve),
          children: [
            //折线图
            {
              path: "FeaturesRadarLine",
              name: "FeaturesRadarLine",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/FeaturesRadarLine.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 1,
                imgUrl: require("@/assets/cause_analyse/radar_chart-zhe-1.jpg")
              }
            },
            //柱状图
            {
              path: "FeaturesRadarBar",
              name: "FeaturesRadarBar",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/FeaturesRadarBar.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 2,
                imgUrl: require("@/assets/cause_analyse/radar_chart-zhu-1.jpg")
              }
            },
            //面积图
            {
              path: "FeaturesRadarArea",
              name: "FeaturesRadarArea",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/FeaturesRadarArea.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 3,
                imgUrl: require("@/assets/cause_analyse/radar_chart-mian-1.jpg")
              }
            }
          ]
        },
        {
          path: "particulateMatter",
          name: "ParticulateMatter",
          meta: {
            order: 9,
            title: "污染来源定向分析",
            subtitle: "颗粒物组分分析"
          },
          component: resolve =>
            require([
              "@/view/causeAnalyse/sourceOrientation/particulateMatter.vue"
            ], resolve),
          children: [
            //堆叠图
            {
              path: "ParticulateMatterStack",
              name: "ParticulateMatterStack",
              component: resolve =>
                require([
                  "@/view/causeAnalyse/echarts/ParticulateMatterStack.vue"
                ], resolve),
              props($route) {
                return {
                  seriesData: $route.query.seriesData,
                  chartEditor: $route.query.chartEditor
                };
              },
              meta: {
                imgId: 3,
                imgUrl: require("@/assets/cause_analyse/component.png")
              }
            }
          ]
        },
        {
          path: "sourceResolution",
          name: "SourceResolution",
          meta: {
            order: 10,
            title: "在线源解析"
          },
          component: resolve =>
            require(["@/view/causeAnalyse/sourceResolution.vue"], resolve)
        },
      ]
    },
    {
      path: "/sourceResolutionShow",
      name: "sourceResolutionShow",
      component: resolve => require(["@/view/causeAnalyse/sourceResolutionShow.vue"], resolve)
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js